import angular from 'angular';

module.exports = angular.module('common.models.humanAvailability', [
  require('angular-resource')
])
.factory('HumanAvailability', function(odResource) {
  return odResource('/api/v1/humans/:human_id/availabilities/:id', {
    human_id: '@human_id',
    id: '@id'
  }, {
    update: {
      method: 'PATCH',
      toast: {
        error: 'Failed to update availability',
        success: 'Updated availability',
      }
    },
    save: {
      method: 'POST',
      toast: {
        error: 'Failed to save availability',
        success: 'Successfully scheduled availability'
      }
    },
  });
}).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/models/human_availability.js
 **/